'use client'

import { Box, Typography } from '@mui/material'
import { useLocale } from 'next-intl'
import Image from 'next/image'
import React, { createContext, useLayoutEffect, useRef, useState } from 'react'
import tell from './tell.png'

const BADGE_GAP = 8

export const CheapestQuickestBadgeWidthContext = createContext<number>(0)

interface CheapestQuickestCardLabelProps {
    children: React.ReactNode
    label: string
    isActive: boolean
    sortOptionId: string
    isMobile: boolean
    isCombined?: boolean
}

const CHEAPEST_COLOR = '#0FA670'
const QUICKEST_COLOR = '#3B82F6'

const colorMap = {
    cheapest: CHEAPEST_COLOR,
    quickest: QUICKEST_COLOR
}


const CheapestQuickestNew: React.FC<CheapestQuickestCardLabelProps> = ({
    children,
    isActive,
    label,
    sortOptionId,
    isMobile,
    isCombined
}) => {
    const locale = useLocale()
    const isArabic = locale === 'ar'
    const badgeRef = useRef<HTMLDivElement>(null)
    const [badgeWidth, setBadgeWidth] = useState(0)

    const measureBadge = React.useCallback(() => {
        if (badgeRef.current) {
            setBadgeWidth(badgeRef.current.offsetWidth)
        }
    }, [])

    useLayoutEffect(() => {
        measureBadge()
        const el = badgeRef.current
        if (!el) return
        const observer = new ResizeObserver(measureBadge)
        observer.observe(el)
        return () => observer.disconnect()
    }, [label, isCombined, locale, measureBadge])

    const ids = isCombined ? sortOptionId.split('_') : [sortOptionId]
    const labels = isCombined ? label.split('_') : [label]
    const badgeLeftOffset = badgeWidth > 0 ? badgeWidth - 10 + BADGE_GAP : 0

    return (
        <CheapestQuickestBadgeWidthContext.Provider value={badgeLeftOffset}>
            <Box position={"relative"} >
                <Image src={tell} alt='tell' width={10} height={10} style={{
                    position: "absolute",
                    top: 20,
                    ...(isArabic ? { right: -10 } : { left: -10 }),
                    transform: isArabic ? 'scaleX(-1)' : 'none',

                    zIndex: 10,
                }} />
                <Box
                    ref={badgeRef}
                    display={'flex'}
                    justifyContent={'flex-start'}
                    position={"absolute"}
                    top={0}
                    left={-10}
                    zIndex={10}
                    gap={1}
                >
                    {ids?.map((id, index) => {
                        return (
                            <Box
                                key={id}
                                bgcolor={colorMap[id as keyof typeof colorMap]}
                                // width={'100px'}
                                px={1}
                                sx={{
                                    borderRadius: "4px",
                                    ...(index === 0 && { borderBottomLeftRadius: 0 }),
                                }}
                            >
                                <Typography variant="body2" color={'white'} textAlign={'center'} fontWeight={600}>
                                    {labels[index]}
                                </Typography>
                            </Box>
                        )
                    })}
                </Box>

                <Box
                    borderRadius={isMobile ? 2 : 1}
                >
                    {children}
                </Box>
            </Box>
        </CheapestQuickestBadgeWidthContext.Provider>
    )
}

export default CheapestQuickestNew
